import {
    GET_ERRORS
} from './type';
import PaymentMethod from '../Models/PaymentMethod';
import Request from '../Models/Request';

export const paymentMethod = (userId, data, history) => dispatch => {
    // let i=[];
    console.log(data);
    if (data.request_id !== '' && data.request_id !== null && data.flag === '') {
        PaymentMethod.create(data).then(res => {
            console.log(res.data.status)
            if (parseInt(res.data.status) === 200) {
                if (userId === 1) {
                    history.push('/buyer-transaction');
                } else if (userId === 2) {
                    history.push('/seller-buyer-transaction');
                }
                if (userId === 3) {
                    history.push('/affiliator-buyer-transaction');
                }
            } else if (parseInt(res.data.status) === 10061){
                console.log(res.data.status)
                window.location.reload();
                alert("ポイントが不足しています！");
            } else {
                alert("データを取得できませんでした！ 後で試してください");
            }

        })
        .catch(
            console.log('err')
        )
        // Request.executeAcceptance(data).then(res => {
        //         if (res.data.status === 200) {
        //             if (userId === 1) {
        //                 history.push('/buyer-transaction');
        //             } else if (userId === 2) {
        //                 history.push('/seller-buyer-transaction');
        //             }
        //             if (userId === 3) {
        //                 history.push('/affiliator-buyer-transaction');
        //             }
        //         }
        //     })
        //     .catch(
        //         console.log('err')
        //     )
    } else {
        PaymentMethod.create(data).then(res => {
                if (parseInt(res.data.status) === 200) {
                    if (userId === 1) {
                        history.push('/buyer-transaction');
                    } else if (userId === 2) {
                        history.push('/seller-buyer-transaction');
                    }
                    if (userId === 3) {
                        history.push('/affiliator-buyer-transaction');
                    }
                } else if (parseInt(res.data.status) === 10061){
                    window.location.reload();
                    alert("ポイントが不足しています！");
                } else {
                    alert("データを取得できませんでした！ 後で試してください")
                }

            })
            .catch(
                console.log('err')
            )
    }

};